import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'

import { CenteredContent, FlexEndButtonErrorContainer, PageWithTitle } from '../styles/Containers'
import { SecondaryButton } from '../common/Button'
import ConfirmationTemplate from '../common/ConfirmationTemplate'
import Loading from '../common/Loading'
import DownloadResponseButton from './DownloadResponseButton'
import pirTerminology from '../../util/pirTerminology'

const PageContent = styled(PageWithTitle)`
  padding: 50px;
  width: 100%;
  gap: 50px;
`
// 36px for button height, 100px for padding on PageWithTitle, 50px for gap on PageWithTitle
const ConfirmationContainer = styled(CenteredContent)`
  min-height: calc(100vh - 186px);
`

function ResponseConfirmation({ requestType, isRejected = false, requestId, secondaryId, fileList = [], letter }) {
  const refreshPage = () => window.location.reload(false)

  if (!isRejected && !fileList) return <Loading />

  const buttonText = requestType === 'foi' ? 'Back to FOI' : 'Back to Response Page'
  const longText = requestType === 'foi' ? 'Freedom of Information Request' : pirTerminology.getRequestName()
  const titleText = isRejected ? `${pirTerminology.getRequestShortName()} Rejected` : 'Response successfully sent'

  const bodyText = isRejected
    ? [`Thank you! The ${longText} has been successfully rejected.`, 'A confirmation has been emailed to the requestor and a refund has been issued.']
    : [`Thank you! Your ${longText} response has been successfully emailed to the requestor.`, 'Download a copy of your response below.']

  return (
    <PageContent>
      <div>
        <SecondaryButton onClick={refreshPage}>
          <ArrowBackIosIcon />
          {buttonText}
        </SecondaryButton>
      </div>
      <ConfirmationContainer>
        <ConfirmationTemplate title={titleText} bodyText={bodyText}>
          {!isRejected && (
            <FlexEndButtonErrorContainer gap="5px">
              <DownloadResponseButton
                requestType={requestType}
                requestId={requestId}
                secondaryId={secondaryId}
                fileList={fileList}
                letter={letter}
                label="Download"
              />
            </FlexEndButtonErrorContainer>
          )}
        </ConfirmationTemplate>
      </ConfirmationContainer>
    </PageContent>
  )
}

ResponseConfirmation.propTypes = {
  requestType: PropTypes.oneOf(['foi', 'pir']).isRequired,
  isRejected: PropTypes.bool,
  requestId: PropTypes.string.isRequired,
  secondaryId: PropTypes.string.isRequired,
  fileList: PropTypes.array,
  letter: PropTypes.object
}

export default ResponseConfirmation
